// eslint-disable-next-line no-use-before-define
import React from 'react';
import { DiagnosisAction, DiagnosisState, DEFAULT_DIAGNOSIS_STATE } from './Interface';
const ROPortalDiagnosisContext = React.createContext<{
  state: DiagnosisState;
  dispatch: (action: DiagnosisAction) => void;
}>({ state: DEFAULT_DIAGNOSIS_STATE, dispatch: (): void => {} });

export default ROPortalDiagnosisContext;
